export const connectorLocalStorageKey = "connectorId";
